export default __webpack_public_path__ + "express-rna-seq-visual.svg";